import { Injectable } from '@angular/core';
import { GET_PLAN_STATUS } from './graphql.operations';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GraphqlService {

  constructor(private apollo: Apollo) {
  }

  getPlanStatusByPlanId(planId: string): Observable<string> {
    return this.apollo.watchQuery({
      query: GET_PLAN_STATUS,
      variables: {
        planId: planId,
      },
    }).valueChanges.pipe(
      map(({ data }: any) => {
        const status = data?.getPlanDetailsOrPlanTaxByPlanId?.planLifeCycle?.planStatus;
        return status;
      })
    );
  }
}
